import { makeTranslator } from '../../shared/i18n';
import strings from './strings';

export default makeTranslator(strings);
